// src/tenantAdmin/pages/TenantKnowledgeBasePage.jsx
// Tenant-admin console → Knowledge Base. Route /tenant-admin/knowledge-base.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext.jsx';
import KnowledgeBaseView from '../../context/KnowledgeBaseView.jsx';
import { PAGE_COLUMN } from '../../components/ui/SectionCard.jsx';
import PageBand from '../../components/ui/PageBand.jsx';
import PersonalizationBadge from '../../onboarding/ui/PersonalizationBadge.jsx';

export default function TenantKnowledgeBasePage() {
  const { t } = useTranslation('admin');
  const { activeTenant, isTenantAdmin, user } = useAuth();
  return (
    // 2026-10-01: the console's white band (PageBand) + the personalization badge, content below.
    <div>
      <PageBand
        title={t('knowledgeBase.title')}
        aside={<PersonalizationBadge />}
        // v201: no workspace name in the subtitle.
        subtitle={t('tenantKnowledgeBase.subtitle')}
      />
      <div style={PAGE_COLUMN}>
        <KnowledgeBaseView tenantId={activeTenant?.tenant_id} canWrite={isTenantAdmin} userKey={user?.user_id || user?.email || ''} />
      </div>
    </div>
  );
}
